$(document).ready(function() {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('contact_posted') === 'true') {
    window.location.href = 'https://www.bubsfirst.com.au/pages/thank-you-for-contacting-us';
  }
});
document.addEventListener('DOMContentLoaded', function() {
  const scrollBtn = document.getElementById('scrollToTop');
  if (!scrollBtn) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 300) {
      scrollBtn.style.display = 'flex';
      scrollBtn.style.opacity = '1';
    } else {
      scrollBtn.style.opacity = '0';
      setTimeout(() => {
        scrollBtn.style.display = 'none';
      }, 300);
    }
  });

  scrollBtn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});
